<template>
  <div class="shippers-box" @click="chooseShippers">
    <div class="shippers-box_img">
      <img :src="shippersData.logoPictureUrl ? shippersData.logoPictureUrl : noImage"  @error="defImg()" alt="" />
    </div>
    <div class="shippers-box_text size12">
      <div class="shippers-box_text-name oneLine" :title="(shippersData.zhName)" v-text="(shippersData.zhName)" v-if="this.$i18n.locale==='zh-cn'"></div>
      <div class="shippers-box_text-name oneLine" :title="(shippersData.enName)" v-text="(shippersData.enName)" v-if="this.$i18n.locale==='en'"></div>

<!--      <div class="shippers-box_text-ename oneLine" :title="returnEname(shippersData)" v-if="returnType" v-text="returnEname(shippersData)"></div>-->
    </div>
  </div>
</template>

<script>
import LocalStorage from '@/common/localStorage.js'
const shippersKey = 'shippers-key'
const shippersChoose = 'shippers-choose'
export default {
  data () {
    return {
      noImage: 'this.src = "../../assets/noImage.png")',
      defaultImg: require("../../assets/noImage.png")
    }
  },
  props: {
    shippersData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  created () {

  },
  computed: {
    returnType () {
      return (this.shippersData.carrierType === 'Postal')
    }
  },
  methods: {
    defImg(){
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    chooseShippers () {
      let vm = this
      let local = LocalStorage.get(shippersKey) || []
      let an = local.some(function (t) {
        return t.code === vm.shippersData.code
      })
      if (!an) {
        local.push(this.shippersData)
        LocalStorage.set(shippersKey, JSON.stringify(local))
      }
      LocalStorage.set(shippersChoose, JSON.stringify(this.shippersData))
      this.$emit('shippers-close')
    },
    returnName (item) {
      return this.returnType ? item.country.cnName : item.zhName
    },
    returnEname (item) {
      return this.returnType ? item.name : ''
    }
  }
}
</script>

<style scoped>
  .shippers-box {
    width: 30%;
    height: 35px;
    margin: 10px 10px 10px 0;
    display: flex;
    cursor: pointer;
  }
  .shippers-box:hover {
    background-color: #f7f7f7;
  }
  .shippers-box_img {
    width: 34px;
    height: 35px;
    border: 1px solid #efefef;
  }
  .shippers-box_img img {
    width: 34px;
    height: 34px;
  }
  .shippers-box_text {
    margin: 0 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .shippers-box_text-name, .shippers-box_text-ename {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shippers/shippersBox.vue